import { useEffect } from 'react';

import comment from '@/assets/comment.svg';
import { trackPageview } from '@/lib/analytics';

import { AppShell } from '../app-shell';

const BENEFITS = [
  {
    title: 'Compensation',
    items: [
      'Competitive weekly pay',
      'Instant Pay',
      '401(k)',
      'Licensure assistance and reimbursement',
    ],
  },
  {
    title: 'Benefits',
    items: [
      'Medical insurance',
      'Dental insurance',
      'Health & Supplemental insurance offerings',
      'Professional Liability insurance',
    ],
  },
  {
    title: 'Perks',
    items: [
      'Referral bonuses',
      'MAS Rewards Me bonus program',
      'Operation Happy Nurse - mental health resources',
    ],
  },
] as const;

export function WaitingRoomPage() {
  useEffect(() => {
    trackPageview('waiting room');
  }, []);

  return (
    <AppShell>
      <div className="stack stack--loose">
        <div className="stack">
          <img src={comment} alt="" className="art" />
          <h1>We&apos;re looking forward to speaking soon!</h1>
          <hr className="divider" />
          <p className="lead">
            Our dedicated team will work to help guide you every step of the way. You&apos;ll be
            hearing from us shortly!
          </p>
          <p>
            <a href="https://www.masmedicalstaffing.com" target="_blank" rel="noreferrer">
              Learn more about MAS
            </a>
          </p>
        </div>
        <hr className="divider divider--gray" />
        <div className="stack">
          <h3>Did you know...</h3>
          <p>Becoming part of the MAS family comes with lots of great benefits, including:</p>
          <div className="benefits">
            {BENEFITS.map((b) => (
              <section key={b.title} className="benefit">
                <h4>{b.title}</h4>
                <ul>
                  {b.items.map((i) => (
                    <li key={i}>{i}</li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}
